const _URL = window.location.search;

const _options = {
  customURL: null,
};

const removeFromURL = (queryParamName, options = _options) => {
  if (!queryParamName) return;

  const searchParams = new URLSearchParams(options.customURL || _URL);

  searchParams.delete(queryParamName);
  const newParams =
    searchParams.toString().length > 0 ? "?" + searchParams.toString() : "";
  const newRelativePathQuery = window.location.pathname + newParams;

  window.history.pushState(null, "", newRelativePathQuery);
};

const queryParamsExists = (queryParamName, options = _options) => {
  if (!queryParamName) return;

  const searchParams = new URLSearchParams(options.customURL || _URL);
  return searchParams.has(queryParamName);
};

const getQueryParamValue = (queryParamName, options = _options) => {
  if (!queryParamName) return;

  const searchParams = new URLSearchParams(options.customURL || _URL);
  return searchParams.get(queryParamName);
};

export { removeFromURL, queryParamsExists, getQueryParamValue };
